import React from 'react';

import Loader from '../../../components/Loader';
import SafetyPageForm from '../../../components/siteadmin/SafetyPageSettings/SafetyPageForm';
import { getSafetyPageQuery } from '../../../lib/graphql';
import { mergeSafetySettings } from '../../../helpers/safetyPageDefaults';
import { withQuery } from '../../../hoc/withGraphql';

const SafetySettings = ({ data: { loading, getSafetyPage } }) => {

    if (loading) {
        return <Loader type={'text'} />;
    }

    return <SafetyPageForm initialValues={mergeSafetySettings(getSafetyPage)} />;
};

export default withQuery(getSafetyPageQuery, {
    options: {
        fetchPolicy: 'network-only',
        ssr: false,
    },
})(SafetySettings);
